import {User, UserCredentials} from "../models/User";
import agent from "../api/agent";
import {router} from "../router/Routes";
import {CustomEvents, eventEmitter} from "../events/events";
import {makeAutoObservable, reaction, runInAction} from "mobx";

const PIGINICH_USERNAME: string = 'piginiChUsername';
const PIGINICH_DISPLAYNAME: string = 'piginiChDisplayName';
const PIGINICH_TOKEN: string = 'piginiChToken';

export default class UserStore {
    user: User | null = null;
    isLoading: boolean = false;

    constructor() {
        makeAutoObservable(this)
        this.initUserFromSessionStore();

        reaction(
            () => this.user,
            user => {
                if (user) {
                    sessionStorage.setItem(PIGINICH_USERNAME, user.userName);
                    sessionStorage.setItem(PIGINICH_DISPLAYNAME, user.displayName);
                    sessionStorage.setItem(PIGINICH_TOKEN, user.token);
                } else {
                    sessionStorage.removeItem(PIGINICH_USERNAME);
                    sessionStorage.removeItem(PIGINICH_DISPLAYNAME);
                    sessionStorage.removeItem(PIGINICH_TOKEN);
                }
            }
        );
    }

    get isLoggedIn() {
        return !!this.user;
    }

    private initUserFromSessionStore = () => {
        const username = sessionStorage.getItem(PIGINICH_USERNAME);
        const displayname = sessionStorage.getItem(PIGINICH_DISPLAYNAME);
        const token = sessionStorage.getItem(PIGINICH_TOKEN);
        if (username && displayname && token) {
            this.user = {
                userName: username,
                displayName: displayname,
                token: token
            }
            eventEmitter.emit(CustomEvents.LOGIN);
        }
    }

    login = async (creds: UserCredentials) => {
        runInAction(() => this.isLoading = true);
        try {
            const user = await agent.Account.login(creds);
            if (!!user) {
                runInAction(() => this.user = user);
                eventEmitter.emit(CustomEvents.LOGIN);
                await router.navigate('/');
            }
        } catch (error) {
            // handle in login form
            throw error;
        } finally {
            runInAction(() => this.isLoading = false);
        }
    }

    logout = async () => {
        this.user = null;
        eventEmitter.emit(CustomEvents.LOGOUT);
    }
}

